import { createFileRoute } from "@tanstack/react-router";
import { WithErrorBoundary } from "../../../hoc/with-error-boundary";
import { withPermissionCheck } from "../../../hoc/with-permission-check";
import { UpdateUsernameView } from "../../../views/profile/update-username/update-username-view";

export const Route = createFileRoute("/_profile/profile/update-username")({
  component: () => WithErrorBoundary({ Component: withPermissionCheck({ Component: UpdateUsernameView }) }),
});
